
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.742 3.005L3.625 4.652C3.187 4.73 3 5.04 3 5.262v13.477c0 .221.187.53.625.61l9.117 1.645a.291.291 0 00.224-.044.117.117 0 00.034-.035V3.085a.121.121 0 00-.034-.035.292.292 0 00-.224-.045zm-.355-1.968C13.595.82 14.945 1.625 14.998 3h4.869A3.133 3.133 0 0123 6.133v11.734A3.133 3.133 0 0119.867 21h-4.869c-.052 1.375-1.403 2.181-2.611 1.962L3.27 21.317C2.024 21.091 1 20.067 1 18.739V5.261C1 3.933 2.024 2.91 3.27 2.683l9.117-1.646zM15 19V5h4.867C20.492 5 21 5.507 21 6.133v11.734c0 .625-.508 1.133-1.133 1.133H15zm1.5-12a1 1 0 100 2h2a1 1 0 100-2h-2zm-1 5a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3a1 1 0 100 2h2a1 1 0 100-2h-2zm-5.532-8.384a1 1 0 01.416 1.352L9.249 12l2.135 4.032a1 1 0 11-1.768.936l-1.498-2.83-1.234 2.33a1 1 0 11-1.768-.936L6.986 12l-1.87-3.532a1 1 0 111.768-.936l1.234 2.33 1.498-2.83a1 1 0 011.352-.416z","fill":"#04080E"}})])
          )
        }
      }
    